import { ISelect } from '../../select.model';

class DiscardedDays {
    listDiscardedDays = new Array() as Date[];
    discardedDays: number = 0;
    totalDays: number;
    constructor(nonWorkingDays: any, startDate: Date, endDate: Date, festiveDays: ISelect[]) {
        const dateRange: Date[] = this.getDateRange(startDate, endDate);
        if (nonWorkingDays != undefined || nonWorkingDays != null) {
            dateRange.forEach((date) => {
                const nonWorkday = nonWorkingDays.filter(x => x.id === date.getDay())[0];
                if (nonWorkday !== undefined) {
                    this.listDiscardedDays.push(date);
                }
                festiveDays.forEach(x => {
                    const d = new Date(x.text);
                    if (date.getFullYear() === d.getFullYear() &&
                        date.getMonth() === d.getMonth() &&
                        date.getDate() === d.getDate()) {
                        this.listDiscardedDays.push(d);
                    }
                });
            });
        }

        this.discardedDays = this.listDiscardedDays.length;
    }

    getDateRange(startDate: Date, endDate: Date): Date[] {
        const dates = new Array() as Date[];
        let currentDate = startDate;
        const addDays = function (days) {
            const date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        };
        while (currentDate <= endDate) {
            dates.push(currentDate);
            currentDate = addDays.call(currentDate, 1);
        }
        return dates;
    }
}
class DifferenceDate extends DiscardedDays {
    differenceDateNum: number;
    constructor(nonWorkingDays: any, startDate: Date, endDate: Date, festiveDays: ISelect[]) {
        super(nonWorkingDays, startDate, endDate, festiveDays);
        this.differenceDateNum = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));;
    }
}

export class HolidayRange extends DifferenceDate {
    constructor(nonWorkingDays: any, availableDays: number, startDate: Date, endDate: Date, festiveDays: ISelect[]) {
        super(nonWorkingDays, startDate, endDate, festiveDays);
        this.initDate = startDate;
        this.finalDate = endDate;
        this.availableDays = availableDays;
    }
    listDiscardedDaysToString = new Array() as string[];

    availableDays: number;
    initDate: Date;
    finalDate: Date;
}

